import { FC } from 'react'

import { Icon, MenuOption, typography } from '@joor/design-system'
import styled from 'styled-components'

import { AgGridFilterType, FilterOptionProps } from 'features/Orders/components'

const StyledMenuOption = styled(MenuOption)`
  & > div:first-child {
    width: 100%;
  }

  svg {
    display: none;
  }
`

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;

  width: 100%;

  svg {
    display: block;
    visibility: hidden;
  }

  &.selected {
    ${typography.alpha.primaryActive.body2}
    color: var(--color-secondary-800);

    svg {
      visibility: visible;
      --main-color: var(--color-secondary-800);
    }
  }
`

export const MULTIPLE_VALUE_TEXT = 'Multiple'

export type SetFilterProps = FilterOptionProps & {
  option: string
  values: string[]
  onRemoveFilter: (name: string, value: string) => void
}

export const SetFilter: FC<SetFilterProps> = ({
  name,
  option,
  values,
  onUpdateFilters,
  onRemoveFilter,
}) => {
  const isSelected = values.some((value) => value === option)

  const handleClickOption = (): void => {
    if (isSelected) {
      onRemoveFilter(name, option)
      return
    }

    onUpdateFilters(name, {
      values: [...values, option],
      filterType: AgGridFilterType.Set,
    })
  }

  return (
    <StyledMenuOption key={option} onClick={handleClickOption}>
      <Container className={isSelected ? 'selected' : ''}>
        {option}
        <Icon iconName="checkmark" iconSize="small" />
      </Container>
    </StyledMenuOption>
  )
}
